module.exports = __webpack_public_path__ + "img/icon_numbers_of_account.9250850a.svg";